module.exports = __webpack_public_path__ + "static/13-Small dish with petals & legs-aa6ad7a5d04d72d2aeb0f1172fe04b47.jpg";